import { MentorStateUpdateResponse, UpdateMentorStateRequest } from './../../models/account/mentor/updateMentorState';
import { RegisterMentorRequest } from './../../models/account/mentor/registerMentorRequest';
import { Injectable } from '@angular/core';
import { GenericService } from '../generic.service';
import { Observable } from 'rxjs';
import { loginResponse } from '../../models/account/loginResponse';
import { apiResponse } from '../../models/apiResponse';
import { MentorResponse } from '../../models/account/mentor/mentorResponse';
import { MentorType } from '../../models/enums/enums';
import { StudentMentorResponse } from '../../models/account/mentor/studentMentorResponse';
import { SearchMentorRequest } from '../../models/account/mentor/searchMentorRequest';
import { SearchMentorResponse } from '../../models/account/mentor/searchMentorResponse';
import { AddStudentMentorRequest } from '../../models/account/mentor/addStudentMentorRequest';

@Injectable({
  providedIn: 'root'
})
export class MentorService {

  constructor(private genericService: GenericService) { }

  registerUser(RegisterMentorRequest: RegisterMentorRequest):Observable<loginResponse>
  {
    return this.genericService.post(`user/registermentor`,RegisterMentorRequest);
  }

  getMentors(mentorType:MentorType):Observable<apiResponse<MentorResponse[]>>{
    return this.genericService.get(`mentor/${mentorType}`);
  }

  chooseMentor(req:AddStudentMentorRequest):Observable<StudentMentorResponse>{
    return this.genericService.post(`studentMentor`,req);
  }

  getStudentMentors(mentorType:MentorType, studentId?: string):Observable<apiResponse<StudentMentorResponse[]>>
  {
    return this.genericService.get(`studentMentor/${mentorType}${studentId ? `?studentId=${studentId}` : ''}`);
  }

  deleteStudentMentor(mentorId:string):Observable<StudentMentorResponse>{
    return this.genericService.delete(`studentMentor/${mentorId}`);
  }

  getMentor(mentorId:string):Observable<MentorResponse>{
    return this.genericService.get(`${mentorId}/mentor`);
  }

  searchMentor(request:SearchMentorRequest):Observable<apiResponse<SearchMentorResponse[]>>{
    return this.genericService.post(`mentor/search`,request);
  }

  updateMentorState(request:UpdateMentorStateRequest):Observable<MentorStateUpdateResponse>{
    return this.genericService.put(`mentor/state`,request);
  }

  sendCalendlyInvite(mentorId:string):Observable<string>{
    return this.genericService.post(`mentor/calendlyinvite/${mentorId}`,null);
  }

  getMentorScheduleURI(mentorId:string):Observable<string>{
    return this.genericService.get(`mentor/scheduleURI/${mentorId}`);
  }
}
